import React from 'react';
import { Chip } from '@mui/material';

export const serviceRenewalTableColumns = [
  {
    field: 'id',
    headerName: 'ID',
    sortable: true,
    minWidth: 80
  },
  {
    field: 'service_name',
    headerName: 'Όνομα Υπηρεσίας',
    sortable: false,
    minWidth: 200,
    renderCell: (value, row) => row?.original_service?.name || 'N/A'
  },
  {
    field: 'client_name',
    headerName: 'Πελάτης',
    sortable: false,
    minWidth: 150,
    renderCell: (value, row) => row?.original_service?.client?.name || 'N/A'
  },
  {
    field: 'project_name',
    headerName: 'Έργο',
    sortable: false,
    minWidth: 150,
    renderCell: (value, row) => row?.original_service?.project?.name || 'Δεν έχει οριστεί'
  },
  {
    field: 'service_type',
    headerName: 'Τύπος',
    sortable: false,
    minWidth: 120,
    renderCell: (value, row) => {
      const types = {
        'development': 'Ανάπτυξη',
        'hosting': 'Hosting',
        'maintenance': 'Συντήρηση',
        'design': 'Σχεδιασμός',
        'domain': 'Domain',
        'application': 'Εφαρμογή',
        'support': 'Υποστήριξη',
        'seo': 'SEO',
        'consulting': 'Σύμβουλος',
        'training': 'Εκπαίδευση',
        'license': 'Άδεια',
        'other': 'Άλλο'
      };
      return types[row?.original_service?.service_type] || row?.original_service?.service_type || 'N/A';
    }
  },
  {
    field: 'billing_period',
    headerName: 'Χρέωση',
    sortable: false,
    minWidth: 120,
    renderCell: (value, row) => {
      const periods = {
        'one_time': 'Εφάπαξ',
        'monthly': 'Μηνιαία',
        'quarterly': 'Τριμηνιαία',
        'semi_annual': 'Εξαμηνιαία',
        'annual': 'Ετήσια',
        'biennial': 'Διετής'
      };
      return periods[row?.original_service?.billing_period] || row?.original_service?.billing_period || 'N/A';
    }
  },
  {
    field: 'price',
    headerName: 'Τιμή',
    sortable: false,
    minWidth: 100,
    renderCell: (value, row) => `€${parseFloat(row?.original_service?.price || 0).toFixed(2)}`
  },
  {
    field: 'new_start_date',
    headerName: 'Νέα Έναρξη',
    sortable: true,
    minWidth: 120
  },
  {
    field: 'new_end_date',
    headerName: 'Νέα Λήξη',
    sortable: true,
    minWidth: 120
  },
  {
    field: 'status',
    headerName: 'Κατάσταση',
    sortable: true,
    minWidth: 120,
    renderCell: (value) => {
      const statusConfig = {
        pending: { label: 'Εκκρεμής', color: 'warning' },
        completed: { label: 'Ολοκληρωμένη', color: 'success' },
        failed: { label: 'Αποτυχία', color: 'error' },
        cancelled: { label: 'Ακυρωμένη', color: 'default' }
      };
      const config = statusConfig[value] || { label: value, color: 'default' };
      return (
        <Chip
          label={config.label}
          color={config.color}
          size="small"
        />
      );
    }
  }
];

export const renewalStatusOptions = [
  { value: 'pending', label: 'Εκκρεμής' },
  { value: 'completed', label: 'Ολοκληρωμένη' },
  { value: 'failed', label: 'Αποτυχία' },
  { value: 'cancelled', label: 'Ακυρωμένη' }
];

export const getRenewalStatusLabel = (status) => {
  const statusMap = {
    pending: 'Εκκρεμής',
    completed: 'Ολοκληρωμένη',
    failed: 'Αποτυχία',
    cancelled: 'Ακυρωμένη'
  };
  return statusMap[status] || status;
};

export const getRenewalStatusColor = (status) => {
  const colorMap = {
    pending: 'warning',
    completed: 'success',
    failed: 'error',
    cancelled: 'default'
  };
  return colorMap[status] || 'default';
};
